<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <section>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-page-title-layout">
              <div>
                <h1 class="boss-page-title boss-page-title-layout-title">
                  応募者管理
                </h1>
              </div>
              <applicant-display-target
                :applicant-objects="applicantObjects"
                @setDisplayTargets="setDisplayTargets"
                @filteredUpdate="setApplicantObjects"
              />
            </div>
          </div>
          <applicant-filter
            :applicant-objects="applicantObjects"
            @filteredUpdate="setApplicantObjects"
          />
          <div>
            <div class="boss-batch-container clearfix  padding-top-0">
              <div class="float-left boss-check-container">
                全
                <span
                  class="boss-check-number"
                  data-test="displayed-count"
                >{{ displayedCount }}</span>名
              </div>
              <applicant-bulk-update
                :entry-ids="checkedEntryIds"
                data-test="bulk-update"
                @updated="fetchApplicants"
              />
            </div>
          </div>
          <div>
            <div class="boss-layout boss-layout-gap-between">
              <div class="is-boss-only-pc">
                <router-link
                  :to="{ name: 'settingApplicantColumns' }"
                  data-test="settings-applicant"
                  class="boss-button boss-button-compact"
                >
                  <img src="@/assets/images/icon-pen.svg">表示情報を編集
                </router-link>
              </div>
              <sort-pull-down
                :objects="applicantObjects"
                :sort-item-map="sortItemMap"
                @setObjects="setApplicantObjects"
              />
            </div>
          </div>
          <div>
            <div
              id="applicant-applicants"
              data-test="applicant-applicant-wrap"
              class="boss-table-wrap"
            >
              <applicant-applicants
                :display-target="displayTargets"
                :applicant-objects="applicantObjects"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ApplicantApplicants from '@/components/organisms/ApplicantApplicants'
import ApplicantFilter from '@/components/molecules/ApplicantFilter'
import SortPullDown from '@/components/atoms/SortPullDown'
import { applicantResultSort } from '@/lib/labelValueMappings'
import ApplicantBulkUpdate from '@/components/molecules/ApplicantBulkUpdate'
import _ from 'lodash'
import ApplicantDisplayTarget from '@/components/molecules/ApplicantDisplayTarget'
import { mapGetters } from 'vuex'
import Indicator from '@/lib/indicator'

export default {
  name: 'ApplicantTop',
  components: {
    ApplicantDisplayTarget,
    ApplicantApplicants,
    ApplicantFilter,
    SortPullDown,
    ApplicantBulkUpdate
  },
  data () {
    return {
      applicantObjects: [],
      // 子コンポーネントに表示対象者を渡すために追加
      displayTargets: [],
      isFetchCallForActivated: false
    }
  },
  computed: {
    sortItemMap () {
      return applicantResultSort
    },
    checkedEntryIds () {
      return _(this.applicantObjects).filter('isChecked').map(_.property('applicant.id')).value()
    },
    displayedCount () {
      return _(this.applicantObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
        .length
    },
    ...mapGetters('settings', [
      'allStatuses'
    ])
  },
  created () {
    this.fetchApplicants()
  },
  activated () {
    this.isFetchCallForActivated && this.fetchApplicants()
  },
  deactivated () {
    this.$set(this, 'isFetchCallForActivated', true)
  },
  methods: {
    fetchApplicants () {
      Indicator.emitShow()
      this.$http.secured.get('/entry/view/entries')
        .then(response => {
          this.setProperty(response.data)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (applicants) {
      this.$set(this, 'applicantObjects', _(applicants).map(applicant => {
        // 選考ステータスの表示順を付与
        return {
          isShow: true,
          isDisplayTarget: true,
          isChecked: false,
          applicant: _.set(applicant, 'currentSelection.statusOrder', this.getStatusOrder(applicant.currentSelection.statusId))
        }
      }).value())
    },
    setApplicantObjects (applicantObjects) {
      this.$set(this, 'applicantObjects', applicantObjects)
    },
    getStatusOrder (statusId) {
      return statusId ? _.findIndex(this.allStatuses, status => status.id === statusId) : null
    },
    setDisplayTargets (displayTargets) {
      this.$set(this, 'displayTargets', displayTargets)
    }
  }
}
</script>
